import React from 'react';

import { Header } from './Header';
import styles from './Screen.module.scss';

type ScreenProps = {
  progress?: number;
  hideBack?: boolean;
  onBack?: () => void;
  /** center-align the content column (titles, reveals) */
  center?: boolean;
  /** hide the whole header row (progress + back), e.g. the hero */
  hideHeader?: boolean;
  children: React.ReactNode;
  /** sticky bottom area (usually a PrimaryButton) */
  footer?: React.ReactNode;
};

/** Page scaffold: unified Header + scrollable content + optional sticky footer. */
export const Screen: React.FC<ScreenProps> = ({ progress, hideBack, onBack, center, hideHeader, children, footer }) => (
  <div className={styles.screen}>
    {!hideHeader && <Header progress={progress} hideBack={hideBack} onBack={onBack} />}
    <main className={`${styles.content} ${center ? styles.center : ''} ${footer ? '' : styles.noFooter}`}>{children}</main>
    {footer}
  </div>
);

export const Eyebrow: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <p className={styles.eyebrow}>{children}</p>
);

export const Title: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <h1 className={styles.title}>{children}</h1>
);

export const Subtitle: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <p className={styles.subtitle}>{children}</p>
);

export const Options: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className={styles.options}>{children}</div>
);

export default Screen;
